import { action, observable } from 'mobx';
import { apiCaller } from '@services/apiCaller';
import { IRootStore } from '@stores/index';
import { SOURCE_CATEGORIES } from '@components/common/constants';

export interface ISourceDefinitionsListStore {
  sourceDefinitions: ISourceDefinition[];
  rootStore: IRootStore;
  getSourceDefinitions(): void;
  getSourceDef(id: string): ISourceDefinition | undefined;
  getWhSourceDefs(): ISourceDefinition[];
}

type WarehouseSourceOptions = {
  isSqlModelSupported?: boolean;
  syncBehaviours: string[];
  isCredentialsValidationSupported?: boolean;
  isAudienceSupported?: boolean;
};
type AuthOptions = {
  provider?: string;
  oauthRole?: string;
};

const popularSources = [
  'Javascript',
  'HTTP',
  'Android',
  'Node',
  'iOS',
  'Python',
  'AMP',
  'snowflake',
  'google_sheets',
  'webhook',
];

export interface ISourceDefinition {
  id: string;
  name: string;
  category?: string;
  displayName: string;
  reference: string;
  code: string;
  options?: {
    isBeta: boolean;
    image: string;
    hidden?: boolean;
    auth?: AuthOptions;
  } & WarehouseSourceOptions;
  isPopular: boolean;
}

export class SourceDefinitionsListStore implements ISourceDefinitionsListStore {
  @observable public sourceDefinitions: ISourceDefinition[] = [];

  @observable public rootStore: IRootStore;

  constructor(rootStore: IRootStore) {
    this.rootStore = rootStore;
  }

  @action.bound
  public async getSourceDefinitions() {
    const res = await apiCaller().get('/source-definitions');
    const modifiedSourceDefs: ISourceDefinition[] = res.data;
    this.sourceDefinitions = modifiedSourceDefs
      .sort((a, b) => (a.displayName.toLowerCase() > b.displayName.toLowerCase() ? 1 : -1))
      .map((a) => ({ ...a, isPopular: popularSources.includes(a.name) }));
  }

  @action.bound
  public getSourceDef(id: string) {
    return this.sourceDefinitions.find((def: ISourceDefinition) => def.id === id);
  }

  public getWhSourceDefs = () =>
    this.sourceDefinitions.filter((def) => def.category === SOURCE_CATEGORIES.WAREHOUSE);
}
